import { Observable } from "rxjs"

export interface IAdminDashboard {
    title : string, 
    description : string,
    tabType : AdminDashboardEnum
}

export enum AdminDashboardEnum {
    USER = "USER",
    SUPPLIER = "SUPPLIER",
    DEACTIVEUSER = "Deactivated USER",
    MASTER = "MASTER",
    PRS = "Archived PRs",
    REPORT = "Audit Report"
}

export enum AdminMasterEnum {
    DIVISION = "DIVISION",
    PLANT = "PLANT",
    COMPANY_CODE = "COMPANY_CODE",
    ESN = "ESN",
    RELEASESTRATEGY = "PO Release Strategy",
    APPRROVERS = "PO Approvers",
    THRESHOLD = "PO Threshold",
    // QESAPPROVER = "QES Approvers",
    // QESTHRESHOLD = "QES Threshold",
    // QESRELEASECODE = "QES ReleaseCode",
    ESNSERVICE="ESN Service",
    PAYMENTTERM="Payment Term",
    EHS = "EHS",
    QES_MATRIX = "QES Matrix",
    PACKING_CODE = "Packing Code",
    SHIPPING_CODE = "Shipping Code",
    PARTNER_CODE ="Partner Code",
    CONF_CONTROL = "Conf Control",
    COND_TYPE="Condition Type",
    TAX_CODE = "TAX Code",
    GBK = "GBK",
    CLAUSE="Clause",
    DOC_TYPE ="Doc Type",
    YA_PARTNER = "YA PARTNER",
    SERVICE_MATERIAL_DESC = 'Service Material Description',
    GL_ACCOUNT_MASTER = "GL Account",
    COST_CENTER = "Cost Center",
    REPORTING_MANAGER_DETAILS = "Reporting Manager Details",
    CURRENCY = "Currency",
    PLANT_COMPANY_MASTER="Plant Company Master",
    PO_CONFIRMATION_VENDOR_MASTER="PO Confirmation Vendor Master"
}

export interface IAdminMasterTab {
    title : string, 
    description : string,
    tabType : AdminMasterEnum,
    data : any,
    keyName : string,
    isUpload : boolean,
    serviceAPI : (payload : any) => Observable<any>
    payload : (data : any) => any,
    heads : any[]
}